export enum CompletionStatus {
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
  NOT_ATTEMPTED = 'not attempted',
  UNKNOWN = 'unknown'
}

export enum Credit {
  CREDIT = 'credit',
  NO_CREDIT = 'no credit'
}

export enum Entry {
  AB_INITIO = 'ab-initio',
  RESUME = 'resume',
  NONE = ''
}

export enum Mode {
  BROWSE = 'browse',
  NORMAL = 'normal',
  REVIEW = 'review',
}

export enum SuccessStatus {
  PASSED = 'passed',
  FAILED = 'failed',
  UNKNOWN = 'unknown',
}

export enum TimeLimitAction {
  EXIT_MESSAGE = 'exit,message',
  CONTINUE_MESSAGE = 'continue,message',
  EXIT_NO_MESSAGE = 'exit,no message',
  CONTINUE_NO_MESSAGE = 'continue,no message'
}

export default interface CMIInterface {
  _version: string
  completion_status: CompletionStatus
  completion_threshold: string
  credit: Credit
  entry: Entry
  exit: string
  launch_data: string
  learner_id: string
  learner_name: string
  location: string
  max_time_allowed: string
  mode: Mode
  progress_measure: string
  scaled_passing_score: string
  session_time: string
  success_status: SuccessStatus
  suspend_data: string
  time_limit_action: string
  total_time: string
  comments_from_learner: {
    childArray: Array<any>
    _children: string
    _count: string
    toJSON: Function
  }
  comments_from_lms: {
    childArray: Array<any>
    _children: string
    _count: string
    toJSON: Function
  }
  interactions: {
    childArray: Array<any>
    _children: string
    _count: string
    toJSON: Function
  }
  learner_preference: {
    _children: string
    audio_level: string
    language: string
    delivery_speed: string
    audio_captioning: string
    toJSON: Function
  }
  objectives: {
    childArray: Array<any>
    _children: string
    _count: string
    toJSON: Function
  }
  score: {
    _children: string
    scaled: string
    raw: string
    min: string
    max: string
    toJSON: Function
  }
  toJSON: Function
}
